const messengerTypes = [
  'g.bridge.messenger.facebook',
  'g.bridge.messenger.instagram',
]

export function isMessengerRoom(room) {
  return !!messengerTypes.find(
    eventType => !!room.currentState.getStateEvents(eventType, '')
  )
}

export function isFacebookMessengerRoom(room) {
  return !!room.currentState.getStateEvents('g.bridge.messenger.facebook', '')
}

export function isInstagramMessengerRoom(room) {
  return !!room.currentState.getStateEvents('g.bridge.messenger.instagram', '')
}
